const digest = '8e6fde89a0be4d0d1250fe1954615bcca620230d3df8ea07a76bc2f07724a8d6';
const css = `._heroImage_1y6i9_1 {
  width: 100%;
}
`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'heroImage': '_heroImage_1y6i9_1' };
export const heroImage = '_heroImage_1y6i9_1';
export { css, digest };